
































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {$} from '@/facade'
import {OrbitAddOwnerStep} from '@/enums/OrbitAddOwnerStep'
import {getN3InvocationBuilder} from '@/model/wallets/invocationsBuilder'
import {NeoHelper} from '@/helpers/NeoHelper'
import OrbitLoadingTransactionStep from '@/components/orbit/OrbitLoadingTransactionStep.vue'
import OrbitInsufficientGasStep from '@/components/orbit/OrbitInsufficientGasStep.vue'
import OrbitUnexpectedErrorStep from '@/components/orbit/OrbitUnexpectedErrorStep.vue'
import OrbitRejectedByTheUserStep from '@/components/orbit/OrbitRejectedByTheUserStep.vue'
import OrbitSuccessStep from '@/components/orbit/OrbitSuccessStep.vue'
import {OrbitHelper} from '@/helpers/OrbitHelper'

@Component({
  computed: {
    OrbitAddOwnerStep() {
      return OrbitAddOwnerStep
    },
  },
  components: {
    OrbitSuccessStep,
    OrbitLoadingTransactionStep,
    OrbitInsufficientGasStep,
    OrbitUnexpectedErrorStep,
    OrbitRejectedByTheUserStep,
  },
})
export default class OrbitAddOwnerModal extends Vue {
  @Prop({type: String, required: true}) ownerAddress!: string

  currentStep: OrbitAddOwnerStep = OrbitAddOwnerStep.WAITING_SIGNATURE
  transactionHash: string | null = null

  mounted() {
    this.populateResources()
  }

  async populateResources() {
    await OrbitHelper.checkWalletPermissions().catch(() => {
      this.closeModal()
      return
    })

    await this.addOwner()
  }

  async addOwner() {
    try {
      if (!this.ownerAddress) {
        throw new Error('Missing owner address')
      }

      // Validate input early (will throw if invalid)
      NeoHelper.getScriptHashFromAddress(this.ownerAddress)

      const n3InvocationBuilder = getN3InvocationBuilder()
      const addOrbitOwnerInvocation = n3InvocationBuilder.addOrbitOwnerInvocation(
        {
          ownerAddress: this.ownerAddress,
        }
      )

      this.transactionHash = await $.walletAdapter.invokeN3Wallet(
        addOrbitOwnerInvocation
      )
      if (!this.transactionHash) throw new Error('Undefined transaction')

      this.currentStep = OrbitAddOwnerStep.VALIDATING_TRANSACTION

      const isTransactionValid = await NeoHelper.validateTransaction(
        this.transactionHash
      )
      if (!isTransactionValid) throw new Error('Failed to verify transaction')

      this.currentStep = OrbitAddOwnerStep.ADDED

      $.toast.success('system.success.persist')
    } catch (error) {
      this.threatError(error)
    }

    this.closeModal()
  }

  onClickCloseModal() {
    if (
      this.currentStep === OrbitAddOwnerStep.WAITING_SIGNATURE ||
      this.currentStep === OrbitAddOwnerStep.VALIDATING_TRANSACTION
    ) {
      return
    }

    this.closeModal()
  }

  closeModal() {
    this.currentStep = OrbitAddOwnerStep.WAITING_SIGNATURE
    this.$emit('close')
  }

  @Watch('$store.state.walletAdapter.n3.address')
  async onN3AddressChange(address: string | null) {
    if (!address) {
      this.closeModal()
      return
    }

    await OrbitHelper.checkWalletPermissions().catch(() => {
      this.closeModal()
    })
  }

  private threatError(error: any) {
    console.error(error)

    const isNeonWalletRejected =
      error.message && String(error.message).includes('rejected by the user')

    const isNeoLineWalletRejected =
      error.description &&
      error.description === 'The user cancels, or refuses the dapps request'

    if (isNeonWalletRejected || isNeoLineWalletRejected) {
      this.currentStep = OrbitAddOwnerStep.REJECTED_BY_THE_USER
      return
    }

    const hasInsufficientFunds =
      error.message && String(error.message).includes('insufficient funds')
    if (hasInsufficientFunds) {
      this.currentStep = OrbitAddOwnerStep.INSUFFICIENT_GAS
      return
    }

    this.currentStep = OrbitAddOwnerStep.UNKNOWN_ERROR
  }
}
